module.exports = __webpack_public_path__ + "img/Image18.09c94ca3.png";